export const AVAILABLE = 'AVAILABLE';
export const MANUAL_UNAVAILABLE = 'MANUAL_UNAVAILABLE';
export const AUTO_UNAVAILABLE = 'AUTO_UNAVAILABLE';
